import type { FragmentType } from 'src/gql';
import { DateTime } from 'luxon';
import numeral from 'numeral';
import ItemDetailsRow from 'src/components/portfolio/views/item-details-row';
import { isLiabilityTypeName, LIABILITY_TYPE_DISPLAY_NAME } from 'src/constants/account-link';
import { graphql, unmaskFragment } from 'src/gql';

export const ViewLiabilityDialogDetailRowsFragment = graphql(/* GraphQL */ `
  fragment ViewLiabilityDialogDetailRows on Liability {
    name
    type
    currentBalance {
      amount
    }
    originalBalance {
      amount
    }
    acquiredAt
  }
`);

type Props = {
  readonly liabilityFrag: FragmentType<typeof ViewLiabilityDialogDetailRowsFragment>;
};
export function ViewLiabilityDialogDetailRows({ liabilityFrag }: Props) {
  const liability = unmaskFragment(ViewLiabilityDialogDetailRowsFragment, liabilityFrag);

  return (
    <div>
      <ItemDetailsRow detailLabel="Name" value={liability.name} />
      <ItemDetailsRow
        detailLabel="Type"
        value={isLiabilityTypeName(liability.type) ? LIABILITY_TYPE_DISPLAY_NAME[liability.type] : 'other'}
      />
      <ItemDetailsRow detailLabel="Balance" value={numeral(liability.currentBalance.amount).format('$0,0.00')} />
      <ItemDetailsRow
        detailLabel="Original amount"
        value={numeral(liability.originalBalance.amount).format('$0,0.00')}
      />
      <ItemDetailsRow
        detailLabel="Start date"
        value={DateTime.fromISO(liability.acquiredAt).toFormat('LLL dd, yyyy')}
      />
    </div>
  );
}
